<template>
  <header>
    <div class="row" style="width:1400px;margin:auto;">
      <div id="header_left" class="col-lg-3">
        <router-link :to="{name: 'home'}"><img src="../../assets/toplink_logo.png"></router-link>
        <div class="top_menu_btn" @click="menuSlide">
          <div class="top_menu_btn_icon">
            <div class="btn_bar"></div>
            <div class="btn_bar"></div>
            <div class="btn_bar"></div>
          </div>
        </div>
      </div>
      <div id="header_right" class="col-lg-9">
        <div id="top_menu_bar">
          <ul>
            <li v-for="item in menuItems" :key="item.id">
              <a :href="item.linkUrl" v-if="item.linkUrl.indexOf('http') > -1 || item.linkUrl.indexOf('javascript') > -1" target="_blank">{{ item.name }}</a>
              <router-link :to="item.linkUrl" tag="a" v-else>{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
        <div id="contact_block">
          <div id="search_icon">
            <i class="fa fa-search fa-2x"></i>
            <div id="search_box"></div>
          </div>
          <!--<div id="contact_button">
            <a href="javascript:alert('敬請期待');"><span>聯絡我們</span> <i>⇀</i></a>
            <router-link :to="{name: 'contact_us'}"><span>聯絡我們</span> <i>⇀</i></router-link>
          </div>-->
        </div>
        <div class="navbar-tools">
          <template v-for="item in menuBtns">
            <a :href="item.linkUrl" v-if="item.linkUrl.indexOf('http') > -1 || item.linkUrl.indexOf('javascript') > -1" :key="item.id">{{ item.name }}</a>
            <router-link :to="item.linkUrl" tag="a" :key="item.id" v-else>{{ item.name }}</router-link>
          </template>
        </div>
      </div>
    </div>
    <div id="side_menu">
      <div @click="returnHome"><img src="../../assets/toplink_logo.png" alt=""></div>
      <div id="side_menu_search"></div>
      <div id="side_menu_list">
        <ul>
          <li v-for="item in menuItems" :key="item.id">
            <a :href="item.linkUrl" v-if="item.linkUrl.indexOf('http') > -1 || item.linkUrl.indexOf('javascript') > -1" target="_blank">{{ item.name }}</a>
            <router-link :to="item.linkUrl" tag="a" v-else>{{ item.name }}</router-link>
          </li>
          <li><a href="javascript:void(0);"><i class="fa fa-undo"></i>返回</a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'baseHeader',
  props: {},
  data () {
    return {
      menuBtns: [
        // {id: 'menu_btn0', name: '登入 / 註冊', linkUrl: '/'},
        {id: 'menu_btn1', name: 'EN', linkUrl: 'https://partner.top-link.com.tw/en'},
        // {id: 'menu_btn2', name: '繁', linkUrl: '/'}
      ],
      menuItems: [
        {id: 'menu_item0', name: '首頁', linkUrl: '/'},
        {id: 'menu_item1', name: '關於上聯', linkUrl: '/about'},
        {id: 'menu_item6', name: '展覽紀實', linkUrl: '/documentary'},
        {id: 'menu_item2', name: '全年檔期', linkUrl: '/schedule'},
        {id: 'menu_item3', name: '廠商專區', linkUrl: '/partner'},
        {id: 'menu_item4', name: '會員中心', linkUrl: 'https://member.top-link.com.tw/member/profile'},
        {id: 'menu_item5', name: '登入 / 註冊', linkUrl: 'https://member.top-link.com.tw/'}
      ]
    }
  },
  methods: {
    menuSlide(){
      document.getElementById('side_menu').style.right = '0'
    },
    returnHome(){
      document.getElementById('side_menu').style.right = '-100%'
    }
  },
  mounted () {
    (function() {
      var cx = '007819260123049048456:ilm3u9ip1vk';
      var gcse = document.createElement('script');
      gcse.type = 'text/javascript';
      gcse.async = true;
      gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(gcse, s);
      var search_box = document.getElementById('search_box');
      // var side_menu_search = document.getElementById('side_menu_search')
      search_box.innerHTML = '<gcse:search></gcse:search>';
      // side_menu_search.innerHTML = '<gcse:search></gcse:search>';
      document.getElementById('search_icon')
        .getElementsByTagName('i')[0]
        .addEventListener('click', () => {
          search_box.classList.toggle('active')
      });
    })()
    window.onscroll = () => {
      // var app = this
      var app_scrollTop = document.documentElement.scrollTop
      var header = document.getElementsByTagName('header')[0]
      var main = document.getElementById('main')
      if (app_scrollTop > 85 && header.classList !== 'fixed') {
        header.classList.add('fixed')
        main.style.paddingTop = `85px`
      } else if (app_scrollTop <= 85) {
        header.classList.remove('fixed')
        main.style.paddingTop = 0
      }
      // footer scroll_top_btn
      var scroll_top_btn = document.getElementById('scroll_top_btn')
      var footer_h = document.getElementsByTagName('footer')[0].offsetHeight-50
      // height setting
      var w_total_h = document.documentElement.offsetHeight
      var w_view_h = window.innerHeight
      var w_scrolled = document.documentElement.scrollTop
      var w_bottom_line = w_scrolled + w_view_h
      w_bottom_line > w_total_h - footer_h ? scroll_top_btn.style.bottom = footer_h-(w_total_h - w_bottom_line)+50+"px" : scroll_top_btn.style.bottom = "50px"
      // opacity change
      w_scrolled == 0 ? scroll_top_btn.style.opacity = 0 : scroll_top_btn.style.opacity = 1
    }
    var side_menu_list = document.getElementById('side_menu_list')
    side_menu_list.addEventListener('click', () => {
      var app = this
      app.returnHome()
    })
  }
}
</script>

<style lang="sass">
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

body 
  font-family: 'Microsoft JhengHei'
  overflow-x: hidden

header.fixed 
  position: fixed
  top: 0

header 
  display: flex
  width: 100%
  background: white
  z-index: 998
  #header_left
    position: relative
    img
      display: block
      margin: 15px
    .top_menu_btn 
      position: absolute
      display: none // flex
      align-items: center
      justify-content: center
      cursor: pointer
      width: 50px
      height: 50px
      right: 0
      top: 0
      margin: 13px 20px
      .top_menu_btn_icon
        width: 60%
        .btn_bar 
          width: 100%
          border-top: 5px solid #8fc43d
          margin-top: 5px
  #header_right
    display: flex
    justify-content: flex-end
    align-items: center
    margin-top: 20px
    .navbar-tools
      margin-left: 30px
      +pc-width
        // +dp(n)
      a 
        position: relative
        text-decoration: none
        display: inline-block
        font-weight: 400
        color: #f8f9fa
        text-align: center
        vertical-align: middle
        -webkit-user-select: none
        -moz-user-select: none
        -ms-user-select: none
        user-select: none
        background: #6c757d
        border: 1px solid #6c757d
        padding: .375rem .75rem
        font-size: 1rem
        line-height: 1.5
        border-radius: .25rem
        cursor: pointer
        transition: all .15s ease-in-out
        &:hover
          background: #5a6268
        &:focus 
          outline: 0
          box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5)
        &:not(:last-child)
          margin: 0 10px 0 0
    #top_menu_bar > ul
      display: flex
      list-style-type: none
      margin: 0
      padding: 0
      li
        display: block
        a 
          display: block
          position: relative
          padding: 8px
          text-decoration: none
          color: black
          font-weight: bold
          letter-spacing: 1px
          &:hover 
            color: #00a0e9
          &:after
            content: ''
            position: absolute
            display: none
            bottom: 0
            left: 10%
            width: 80%
            border-top: 1px solid #00a0e9
          &:hover:after
            display: block
    #contact_block 
      display: flex
      padding: 8px
      align-items: center
      cursor: pointer
      #contact_button:hover
        i 
          right: 0
          opacity: 1
        span 
          left: 0
      #contact_button > a
        display: block
        text-decoration: none
        padding: 10px
        color: white
        background: #8fc43d
        letter-spacing: 1px
        font-weight: bold
        margin-left: 25px
      #contact_button i 
        position: relative
        right: 10px
        transition: all .5s
        opacity: 0
      #contact_button span
        position: relative
        left: 10px
        transition: all .5s
      #search_icon
        position: relative
        #search_box 
          display: none
          position: absolute
          top: 40px
          left: -270px
          width: 300px
          z-index: 2
          border: 1px solid black
          &.active 
            display: block
            animation: slideInUp .4s ease
  @include pc-width
    #header_left 
      img 
        width: 40%
        max-width: 150px
      .top_menu_btn 
        display: flex
    #header_right
      display: none

#side_menu 
  position: fixed
  width: 100%
  height: 100vh
  background: white
  border-left: 1px solid grey
  z-index: 1000
  right: -100%
  transition: all .5s
  overflow-y: auto
  img 
    display: block
    margin: 15px auto
    cursor: pointer
  #side_menu_search
    border-top: 1px solid grey
  #side_menu_list
    ul
      list-style-type: none
      margin: 0
      padding: 0
      border-top: 1px solid grey
      li 
        display: block
        a
          display: block
          padding: 15px 25px
          font-size: 20px
          text-decoration: none
          color: #00a0e9
          border-bottom: 1px solid grey
          &:hover 
            color: #ff45cd
        &:last-child > a 
          color: #ff45cd
// google search
#gsc-iw-id1, #gsc-iw-id2
  border-radius: 10px
  height: 40px
  font-size: 23px
  font-family: '微軟正黑體'
.gsc-adBlock 
  display: none !important

@-webkit-keyframes slideInUp
  from
    opacity: 0
    -webkit-transform: translateY(-100%)
    transform: translateY(-100%)
  to
    opacity: 1
    -webkit-transform: translateY(0px)
    transform: translateY(0px)

@keyframes slideInUp
  from
    opacity: 0
    -webkit-transform: translateY(-100%)
    transform: translateY(-100%)
  to
    opacity: 1
    -webkit-transform: translateY(0px)
    transform: translateY(0px)

</style>